var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"movie"},[_c('div',{staticClass:"movie-header-container"},[_c('h3',[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"movie-content-container"},[_c('div',{staticClass:"movie-glance-info"},[_vm._v(_vm._s(_vm.year)+" - "+_vm._s(_vm.director))]),_c('div',{staticClass:"movie-description"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }